const VisionMission = () => {
  return (
    <section id="vision" className="section light">

      <h2>🎭 Cultural & National Activities</h2>

      <div className="grid">
        <div className="box">
          <img src="/images/culture.jpg.webp" alt="" />
          <p>Patriotic & Cultural Programs</p>
        </div>

        <div className="box">
          <img className="i2" src="/images/24.webp" alt="" />
          <p>Annual Functions & Celebrations</p>
        </div>

        <div className="box">
          <img className="i2" src="/images/25.webp" alt="" />
          <p>Student Performances</p>
        </div>
      </div>
    </section>
  );
};

export default VisionMission;
